import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const useInViewport = ({ offset, throttleMilliseconds }) => {
  const ref = useRef();

  const [isInViewport, setIsVisible] = useState(false);
  const [currentElement, setRefElement] = useState(ref);

  const onScroll = _.throttle(() => {
    if (!currentElement.current) {
      setIsVisible(false);
      return;
    }
    const { top } = currentElement.current.getBoundingClientRect();
    setIsVisible(top + offset + ref.current.offsetHeight >= 0 && top - offset <= window.innerHeight);
  }, throttleMilliseconds);

  useEffect(() => {
    if (ref.current) {
      setRefElement(ref);
    }
    return () => setRefElement(null);
  }, [ref]);

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true);
    return () => document.removeEventListener('scroll', onScroll, true);
  }, []);

  return { isInViewport, ref };
};

useInViewport.propTypes = {
  offset: PropTypes.number.isRequired,
  throttleMilliseconds: PropTypes.number.isRequired,
};

export default useInViewport;
